export enum LocalStorageKeyEnum {
  RecentSearches = 'recentSearches',
  SHOPPING_JOURNEY_ID = 'SHOPPING_JOURNEY_ID',
  IsSessionExpired = 'IsSessionExpired',
  AuthToken = 'AuthToken',
  IsCookiePolicyClosed = 'IsCookiePolicyClosed',
}
